import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78e7fb77"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu_nav" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("课程列表")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("报名记录")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("待付款")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("发票管理")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("第三方待付款")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("第三方发票管理")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("退出登录")

import { ref } from 'vue'
    import { useRouter } from 'vue-router'
    import { ElMessageBox } from 'element-plus'
    import {GETAuth} from '@/service/index'
    import store from "@/store";
    
export default /*#__PURE__*/_defineComponent({
  props: ['index'],
  setup(__props) {

const props = __props

    const router = useRouter();
    
    let userInfo:any = store.state.user
    const isPay = ref(false)

    if ( userInfo.userInfo.roleId === 1 ||  userInfo.userInfo.roleId === 4 || userInfo.userInfo.userName === 'yanbin') {
        isPay.value = true
    }

    const activeIndex = ref(props.index)

    const handleSelect = (key: string) => {
        activeIndex.value = key
    }

    const goRecords = () => {
        router.replace({
            name: 'Records'
        })
    }

    const goHome = () => {
        router.replace({
            name: 'Home'
        })
    }

    const goPayRecod = () => {
        router.replace({
            name: "PayRecords"
        })
    }
    const goInvoice = () => {
      router.replace({
        name: 'Invoice'
      })
    }

    const goOtherPayRecod = () => {
      router.replace({
        name: 'OtherPayRecords'
      })
    }

    const goOtherInvoice = () => {
      router.replace({
        name: 'OtherInvoice'
      })
    }

    const logout = async () => {
        let { data } = await GETAuth(`/api/logout`)
        if ( data.code === 200 ) {
            store.commit('setUser', null)
            await router.push({
                name: 'Login'
            })
        }
    }

    const logoutHandler = () => {
        ElMessageBox.confirm('您确定要退出登录吗？','提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }
        ).then(() => {
            logout()
        }).catch(() => {
            console.log("取消退出")
        })
    }


return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_menu, {
      "default-active": activeIndex.value,
      class: "el-menu-demo",
      mode: "horizontal",
      onSelect: handleSelect
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_menu_item, {
          index: "1",
          onClick: goHome
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(_component_el_menu_item, {
          index: "2",
          onClick: goRecords
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        (isPay.value)
          ? (_openBlock(), _createBlock(_component_el_menu_item, {
              key: 0,
              index: "3",
              onClick: goPayRecod
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (isPay.value)
          ? (_openBlock(), _createBlock(_component_el_menu_item, {
              key: 1,
              index: "4",
              onClick: goInvoice
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (isPay.value)
          ? (_openBlock(), _createBlock(_component_el_menu_item, {
              key: 2,
              index: "5",
              onClick: goOtherPayRecod
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (isPay.value)
          ? (_openBlock(), _createBlock(_component_el_menu_item, {
              key: 3,
              index: "6",
              onClick: goOtherInvoice
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["default-active"]),
    _createVNode(_component_el_button, {
      type: "danger",
      onClick: logoutHandler
    }, {
      default: _withCtx(() => [
        _hoisted_8
      ]),
      _: 1
    })
  ]))
}
}

})